export default "__VITE_ASSET__CMzgQhHa__"